module.exports = __webpack_public_path__ + "static/media/Location.7f0d5577.svg";